const SocialReportData = () => {

    const data = [
        {
            metric: "Staff turnover",
            question: "What is the percentage of employees leaving p.a./total employees?",
            unit: "Percentage",
            sector: "General",
            year: 2021,
            value: "2%"
        },
        {
            metric: "Training & qualification",
            question: "What is the percentage of trained employees p.a./total employees ?",
            unit: "Number",
            sector: "General",
            year: 2021,
            value: "68%"
        },
        {
            metric: "Training & qualification",
            question: "What is the annual training hours per employee ?",
            unit: "Hours / Employee",
            sector: "General",
            year: 2021,
            value: "740"
        },
        {
            metric: "Number of employees",
            question: " What is the number of employees by employment type(full time and part time)(by gender) ?",
            unit: "Number",
            sector: "General",
            year: 2021,
            value: "1080"
        },
        {
            metric: "Health & safety aspects of products",
            question: "What is the  total spendings on product safety / revenue ?",
            unit: "Percentage",
            sector: "General",
            year: 2021,
            value: "40%"
        },
        {
            metric: "Diversity",
            question: "What is the percentage of female employees as of total ?",
            unit: "Percentage",
            sector: "General",
            year: 2021,
            value: "48%"
        }

    ]

    return (
        <>
            {
                data && Object.keys(data).length > 0 ? (data.map((curData, index) => {
                    const { question, year, metric, unit, sector, value } = curData;

                    return (
                        <tr key={index}>
                            {/* <td>{supplier}</td> */}
                            <td>{year}</td>
                            <td>{metric}</td>
                            <td>{question}</td>
                            <td>{value}</td>
                            {/* <td>{unit}</td> */}
                            {/* <td>{sector}</td> */}
                        </tr>
                    )
                })
                ) : (
                    <span>No Social reports data available.</span>
                )
            }
        </>
    )
}

export default SocialReportData;